import React, { useEffect, useMemo, useState } from 'react';
import { MaterialReactTable } from 'material-react-table';
import { covidUrl } from '../../../constants/const';
import axios from 'axios';
import { Container } from '@mui/material';



const Covid = () => {
    //should be memoized or stable
    const columns = useMemo(
        () => [
            {
                accessorKey: 'active', //access nested data with dot notation
                header: 'Activecase',
                size: 150,
            },
            {
                accessorKey: 'confirmed',
                header: 'ConfirmedCase',
                size: 150,
            },
            {
                accessorKey: 'recovered',
                header: 'Recovered',
                size: 150,
            },
            {
                accessorKey: 'deaths',
                header: 'Deathes',
                size: 150,
            },

            {
                accessorKey: 'statecode',
                header: 'Statecode',
                size: 150,
            },
            {
                accessorKey: 'state',
                header: 'State',
                size: 150,
            },
        ],
        [],
    );

    const [data, setData] = useState('')

    const fetchCovidData = async (url) => {
        const res = (await axios.get(url)).data;
        console.log(res.statewise)
        setData(res.statewise)
    }

    useEffect(() => {
        fetchCovidData(covidUrl)
    }, [])
    console.log("data", data)
    return (
        <Container sx={{marginTop:"20px"}}>
           Covid19 Data
            <MaterialReactTable
                columns={columns}
                data={data} 
            />
    </Container>



     
  
  
  )
};

export default Covid;
